// import 'reflect-metadata';
import Util from '../../../../bower_components/teknisavuecomponents/assets/utils/Util';
import store from '../../../store/store';
import router, { getRegistroPontoRoute } from '@/Router';
import { Route } from 'vue-router/types/router';
import environment from '@/assets/ts/configuration/environment';
import CameraController from '@/assets/ts/controller/CameraController';
import PopupController from '@/assets/ts/controller/PopupController';
import LocalStorage from '@/../bower_components/teknisavuecomponents/assets/localStorage/localStorage';
import Constants from '@/assets/ts/configuration/Constants';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import axios from 'axios';
import Messages from '../utils/Messages';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import LoadingController from './LoadingController';
import LoginErrors from '../utils/LoginErrors';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import InvalidMaskMessages from '../utils/InvalidMaskMessages';
import LoginErrorMessages from '../utils/LoginErrorMessages';
import OfflineController from '@/assets/ts/controller/OfflineController';
import DynamicRepository from '@/assets/ts/offline/repository/DynamicRepository';
import { findRoute } from '@/routes';

interface UserData {
  EXPIRED_PASSWORD: string;
  LOGGED: string;
  REDIRECT_URL: string;
  TOKEN: string;
  USER: string;
  USER_EMAIL: string;
  USER_ID: string;
  USER_NAME: string;
}

interface DadosOperador {
  NRORG: string;
  NRVINCULOM: string;
  NMESCALATRABH: string;
  NMRAZSOCESTRUT: string;
}

interface LoginVerificationParams {
  videoCameraVideoTagId: string;
}

const projectPath = Constants.PROJECT_PATH;
const loginBackendPath = Constants.LOGIN_BACKEND_PATH;

const http = axios.create({
  baseURL: projectPath + loginBackendPath,
});

export default class LoginController {
  private static readonly defaultPage = '/';

  private static readonly staticMessages = {
    loginFail: 'Não foi possível realizar o login. Por favor, tente novamente mais tarde.',
    noLoginFound: 'Usuário/senha incorretos!',
    initSessionFailed: 'Não foi possível iniciar a sessão. Por favor, tente novamente mais tarde',
    updatePasswordFail: "Não foi possível alterar a senha. Por favor, tente novamente mais tarde",
    resetPasswordFail: 'Não foi possível redefinir a senha. Por favor, tente novamente mais tarde',
  };

  private static TYPE_RESET_PASSWORD = 'RESET_PASSWORD';

  public static async redirect(to: Route, from: Route, next: Function, params: LoginVerificationParams = null) {
    try {
      const isLoggedIn = this.isTokenValid();
      const userInfoIsLoaded = !Util.isEmptyOrBlank(store.getters.user.id);

      if (params && params.videoCameraVideoTagId) {
        CameraController.stopUsingCameraDevice(params.videoCameraVideoTagId);
      }

      if (isLoggedIn) {
        if (!userInfoIsLoaded) {
          await environment.loadInfoIntoStore();
        }

        this.redirectToRegistroPonto(to, next);

        if (to.path === '/login') {
          next(this.defaultPage);
        } else {
          next();
        }
      } else {
        if (to.path === '/login') {
          next();
        } else {
          next('/login');
        }
      }
    } catch (err) {

    }
  }

  public static async redirectToDefaultPage() {
    try {
      await environment.loadInfoIntoStore();
      router.push(this.defaultPage);
      return {
        loginValido: true,
      };
    } catch (err) {
      return {
        loginValido: false,
        message: err,
      };
    }
  }

  public static async redirectToLogin(timeout: number = 0) {
    setTimeout(() => {
      window.localStorage.clear();
      location.reload();
    }, timeout)
  }

  private static isTokenValid(): boolean {
    return !!window.localStorage.getItem('TOKEN');
  }

  public static afterLogin() {
    location.reload();
  }

  public static async requestLogin(email: string, password: string, loginAttempts: number = 0) {

    const filter = [
      {
        name: 'EMAIL',
        operator: '=',
        value: email,
      },
      {
        name: 'PASSWORD',
        operator: '=',
        value: password,
      },
      {
        name: 'PRODUCT_ID',
        operator: '=',
        value: Constants.PRODUCT_ID,
      },
      {
        name: 'REQUESTER_URL',
        operator: '=',
        value: document.location.href,
      },
      {
        name: 'ATTEMPTS',
        operator: '=',
        value: loginAttempts,
      },
    ];

    // Requesting to login module
    LoadingController.showLoading();
    
    try {
      const loginResponse = await http.post('/login', {requestType: 'FilterData', filter });
      return loginResponse;
    } finally {
      LoadingController.hideLoading();
    }
  }

  public static async login(email: string, password: string) {
    try {
      this.handleLoginAtempt();
      const loginAttempts: number = this.getLoginAttempts();
      const loginResponse = await this.requestLogin(email, password, loginAttempts);

      if (loginResponse.data.error) {
        const errorCode: number = loginResponse.data.errorCode;
        const errorMessage = LoginErrors.getErrorMessage(errorCode);

        throw new ExpectedError(errorMessage);
      }

      if (!loginResponse.data.dataset) {
        throw 0;
      }

      const userData = loginResponse.data.dataset.userData;

      if (userData.EXPIRED_PASSWORD && userData.EXPIRED_PASSWORD == this.TYPE_RESET_PASSWORD) {
        // Chama o popUp de alterar senha já colocando a senha resetada
        PopupController.openChangePasswordPopUp({ ACTUAL_PASSWORD: password, EMAIL: email });
        return { login: false, message: Messages.AFTER_LOGIN_PASSWORD_RESETED, type: SnackbarUtils.TYPE_ALERT };
      }

      // Starting session
      const startSessionResponse = await HttpRequest.post('/startSession', {
        requestType: 'Row',
        row: {
          IS_LOGGED: userData.LOGGED,
          USER: userData.USER,
          LOGIN_TOKEN: userData.TOKEN,
        }
      }, false);

      if (!startSessionResponse.data.dataset.system) {
        const message = LoginErrorMessages.getInitSessionMessage();
        throw message;
      }

      const totalDataReturn = { ...startSessionResponse.data.dataset.system, ...userData };

      // Set localStorage data
      this.addUserDataIntoLocalStorage(totalDataReturn);

      this.afterLogin();
      return { login: true };
    } catch (err) {
      const errAny: any = err;

      const errIsMessage = typeof err === 'string';
      const errIsResponseError = !!errAny.response;

      let message = '';

      if (err instanceof ExpectedError) {
        message = err.message;
      } else if (errIsMessage) {
        message = errAny;
      } else if (errIsResponseError) {
        message = errAny.response.data.error;
      } else {
        message = LoginErrors.DEFAULT_ERROR_MESSAGE;
      }

      return { login: false, message };
    } finally {
      LoadingController.hideLoading();
    }
  }

  private static addUserDataIntoLocalStorage(userData: any): void {
    const localStorage = new LocalStorage();

    localStorage.setItemsFromObject(userData);
  }

  private static handleLoginAtempt() {
    let loginAttempts = this.getLoginAttempts();
    loginAttempts++;
    window.localStorage.setItem('LOGIN_ATTEMPTS', loginAttempts.toString());
  }

  private static getLoginAttempts(): number {
    return parseInt(window.localStorage.getItem('LOGIN_ATTEMPTS'), 10) || 0;
  }

  public static async logout(timeout: number = 0) {
    try {
      const response = await HttpRequest.post('/logout', {
        requestType: 'Row',
        row: {

        }
      });
    } catch (err) {

    }

    if(OfflineController.isMobile()) {
      await DynamicRepository.deleteAllTables();
    }

    this.redirectToLogin(timeout);
  }

  public static async updatePassword(senhaAtual: string, novaSenha: string, novaSenhaConfirm: string, email: string = null) {
    try {
      const filter = [
        {
          name: 'ACTUAL_PASSWORD',
          operator: '=',
          value: senhaAtual,
        },
        {
          name: 'NEW_PASSWORD',
          operator: '=',
          value: novaSenha,
        },
        {
          name: 'CONFIRM_NEW_PASSWORD',
          operator: '=',
          value: novaSenhaConfirm,
        },
        {
          name: 'EMAIL',
          operator: '=',
          value: email ? email : window.localStorage.USER_EMAIL,
        },
      ];

      // Requesting to login module
      const loginResponse = await http.post('/updatePassword', {requestType: 'FilterData', filter });
      if (!loginResponse.data || loginResponse.data.error) {
        // Verifica por mensagens padrão
        const error: string = loginResponse.data.error;
        const message = LoginErrorMessages.getChangePasswordMessage(error);

        const data = {
          success: false,
          message,
        };

        return data;
      }

      return { success: true }
    } catch (err) {
      const errIsMessage = typeof err === 'string';
      const errIsResponseError = (err as any).response;

      const message = errIsMessage ? err : (errIsResponseError ? (err as any).response.data.error : this.staticMessages.updatePasswordFail);
      return { success: false, message };
    }
  }

  public static async resetPassword(email: string) {
    try {
      const filter = [
        {
          name: 'EMAIL',
          operator: '=',
          value: email,
        },
      ];

      // Requesting to login module
      const loginResponse = await http.post('/requestNewPassword', {requestType: 'FilterData', filter });
      if (!loginResponse.data || loginResponse.data.error) {
        // Verifica por mensagens padrão
        const error: string = loginResponse.data.error;
        const message = LoginErrorMessages.getResetPasswordMessage(error);

        const data = {
          success: false,
          message,
        };

        return data;
      }

      return { success: true }
    } catch (err) {
      const errIsMessage = typeof err === 'string';
      const errIsResponseError = !!(err as any).response;

      const message = errIsMessage ? err : (errIsResponseError ? (err as any).response.data.error : this.staticMessages.resetPasswordFail);
      return { success: false, message };
    }
  }

  public static openChangePasswordPopUp() {
    PopupController.openPopup('changePassword');
  }

  public static async findPrivacyPolicyByAuthentication(user: string) {
    LoadingController.showLoading();
    try {
      const filter = [
        {
          name: 'USER',
          operator: '=',
          value: user,
        },
      ];
      const response = await http.post('/findPrivacyPolicyByAuthentication', {requestType: 'FilterData', filter });
      const pdfUrl = response.data.dataset.findPrivacyPolicyByAuthentication[0].path;
      return pdfUrl;
    } catch (err) {

    } finally {
      LoadingController.hideLoading();
    }
  }

  public static async forgotPasswordPopupHandler(email: string) {
    const beforePasswordData = await this.getBeforeForgotPasswordInfo(email);
    if (!beforePasswordData || (Array.isArray(beforePasswordData) && beforePasswordData.length == 0)) {
      SnackbarUtils.showMessage('Não existe registro de operador para o Usuário informado. Verifique as informações e tente novamente.', SnackbarUtils.TYPE_ERROR);
      return;
    }

    const confirmationResetIsRequired = beforePasswordData.SHOW_CONFIRMATION_RESET == 'S';
    if (!confirmationResetIsRequired) {
      PopupController.openResetPasswordPopUp({ EMAIL: email });
      return;
    }

    PopupController.openConfirmationResetPasswordPopUp({ EMAIL: email, CDOPERADOR: beforePasswordData.CDOPERADOR, NRORG: beforePasswordData.NRORG });
  }

  public static async getBeforeForgotPasswordInfo(email: string): Promise<any> {
    const route = 'getBeforeForgotPasswordInfo';
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      DSEMAILOPER: email,
    });
    return response && response.data ? response.data.dataset[route][0] : null;
  }

  public static async validateConfirmationResetPassword(cdOperador: string, email: string, dtNascimento: string, dtAdmissao: string, cpf: string) {
    const route = 'validaLoginOperador';
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      CDOPERADOR: cdOperador,
      EMAIL: email,
      DTNASCPESSOA: dtNascimento,
      DTADMISSAOVINC: dtAdmissao,
      NRCPFPESSOA: cpf,
    });

    return response && response.data ? response.data.dataset[route][0] : null;
  }

  public static async confirmationChangePassword(data: any = {}) {
    const route = 'confirmationChangePassword';

    try {
      const response = await HttpRequest.post(route, {
        requestType: 'Row',
        row: data
      });

      return response && response.data ? response.data.dataset[route] : null;
    } catch (err) {
      const errAny: any = err;

      if (errAny.response) {
        const error: string = errAny.response.data.error;
        const errorMessage = LoginErrorMessages.getConfirmationChangePasswordMessage(error);
        errAny.response.data.error = errorMessage;
      }

      throw err;
    }

  }

  private static redirectToRegistroPonto(to: Route, next: Function) {
    const route = findRoute(to.path);
    const registroPontoRoute = getRegistroPontoRoute();
    const isOffline = OfflineController.checkIsOffline();

    /**
     * Restrição que exige que todos os usuários digitem a senha ao tentar sair da tela de registro,
     * se tiverem entrado nela anteriormente.
    */
    const idpgrestringeregist = store.getters.user.idpgrestringeregist;

    /**
     * Restrição que limita o acesso de determinados tipos de usuários ou operadores (Perfil Acesso) a certas telas específicas.
    */
    const idpgrestringetelaregist = store.getters.user.idpgrestringetelaregist;


    // Verifica se o usuário tem a restrição de estado/momento (deve digitar a senha) e se não está offline.
    if (idpgrestringeregist && to.path !== registroPontoRoute && !isOffline) {
      next(registroPontoRoute);
    }

    // Verifica se o usuário tem a restrição de tipo de usuário (Perfil Acesso) (acesso a determinadas telas).
    if(idpgrestringetelaregist && !route.offline) {
      next(registroPontoRoute);
    }

  }

}
